import { render, staticRenderFns } from "./ExpedientCourtsComponent.vue?vue&type=template&id=03f42b4c"
import script from "./ExpedientCourtsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpedientCourtsComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f42b4c')) {
      api.createRecord('03f42b4c', component.options)
    } else {
      api.reload('03f42b4c', component.options)
    }
    module.hot.accept("./ExpedientCourtsComponent.vue?vue&type=template&id=03f42b4c", function () {
      api.rerender('03f42b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientCourts/ExpedientCourtsComponent.vue"
export default component.exports